import React from "react";

export const ImageQuestionAnswers = (props) => {
    return (
        <>
            <div className="sb-quest-answers">
                {props.children}
            </div>
        </>
    )
}